import { render, staticRenderFns } from "./CalculateSalaryProcessLevyBesDetail.vue?vue&type=template&id=a9241b2a&"
import script from "./CalculateSalaryProcessLevyBesDetail.vue?vue&type=script&lang=js&"
export * from "./CalculateSalaryProcessLevyBesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports